<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
        </v-overlay>

      <v-row class="pa-2" no-gutters>
        <custom-popup
          v-model="ready"
          :cons="{ title: $t('ready_card_samples') }"
          hide-confirm
          hide-overlay
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-sample-ready-card-visit-d`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('ready_card_sample')"
            />
          </template>
          <v-card class="p-5" flat>
            <prepared-cards
              v-model="cardTexts"
              :orders.sync="orders"
              :theme.sync="theme"
              type="visitcardpro"
              @closeModel="ready = false"
            />
          </v-card>
        </custom-popup>

        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true">
              {{ $t("show_qr") }}
            </v-tab>
            <v-tab :ripple="true"> {{ $t("preview") }} </v-tab>
            <v-tab :disabled="e6 <= 1" :ripple="true"> تعرفه‌ها </v-tab>

          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <div class="d-flex flex-column justify-center align-center">
                <qr-maker :loading="loading" :svg="svgMade" />
                <v-btn class="btn-download" @click="showDialog = true">
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}                </v-btn>
              </div>
            </v-tab-item>

            <v-tab-item style="position: relative; min-height: 100%;">
              <div class="sticky-preview">
              <component
                :is="theme"
                v-model="cardTexts"
                :data="cardTexts"
                :orders.sync="orders"
                :qr-svg-data-url="qrSvgDataUrl"
              />
              </div>
            </v-tab-item>
            <v-tab-item v-if="!!info?.id && e6>1">
                <Tariffs :id_qr="info.id" :qrtype="'visitcardpro'" />
             </v-tab-item>

          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-row class="pa-2" justify="start" style="width: 100%">
            <v-col
              cols="12"
              sm="12"
              md="6"
              class="box"
              v-if="e6 === 1 && showconnect"
            >
              <v-text-field
                v-model="connectionCode"
                class="connect rounded-lg compact-text-field"
                dense
                :label="$t('connection_code')"
                outlined
                clearable
              >
              </v-text-field>
            </v-col>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <v-row no-gutters>
                  <v-col class="pa-2" cols="12">
                    <p>{{ $t("enter_visit_card_pro_info") }}</p>
                  </v-col>

                  <v-col class="pa-2 d-flex row rowinfo" cols="12" md="6">
                    <v-text-field
                      v-model="cardTexts.visitName"
                      :disabled="e6 > 1"
                      :error-messages="errors['title']"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      :label="$t('visit_card_name_pro')"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-visitName_pro`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('visit_card_name_pro')"
                    />
                  </v-col>

                  <v-col class="pa-2 rowinfo" cols="12" md="6">
                    <qr-address-field
                      id="qr-address"
                      ref="address-field"
                      v-model="dtUrl"
                      :disabled="e6 > 1"
                      :error-messages="errors['identifier']"
                      append-icon="mdi-web"
                      class="ma-0 pa-0 contentinfo"
                      width="88%"
                      dense
                      :key="$t('qrAddressUpdate.hints.allowedChars')"
                      :hint="$t('qrAddressUpdate.hints.allowedChars')"
                      outlined
                      persistent-hint
                      @updateDest="domainId = $event"
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-dtUrl`"
                      :label="$t('qr_address')"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                    />
                  </v-col>
                </v-row>
              </v-stepper-step>
              <v-stepper-content step="1">
                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="markQr"
                  />
                </div>
              </v-stepper-content>

              <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
                {{ $t("info") }}
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
                <div class="d-flex row mx-2 mt-3 mb-4 justify-start doublebtn">
                  <v-btn
                    :disabled="e6 > 2"
                    class="mx-0"
                    color="third"
                    outlined
                    @click="clearDefaults"
                  >
                    <v-icon class="me-2">mdi-delete</v-icon>
                    {{ $t("remove_default_info") }}
                  </v-btn>
                  <help-info
                    class="buttoninfo mx-0"
                    :element-name="`${serviceName}-${componentName}-clearDefaults`"
                    :label="$t('remove_default_info')"
                    :service-name="serviceName"
                    :help-data="helpData"
                  />
                  <v-btn
                    class="btn-download mt-0 mx-0"
                    depressed
                    @click="ready = true"
                  >
                    {{ $t("select_ready_card") }}
                  </v-btn>
                  <help-info
                    class="buttoninfo mx-0"
                    :element-name="`${serviceName}-${componentName}-preparedCards`"
                    :label="$t('select_ready_card')"
                    :service-name="serviceName"
                    :help-data="helpData"
                  />
                        <div class="mb-4">
                        <!-- سوییچ و آیکون راهنما -->
                        <div class="d-flex align-center">
                          <v-switch
                            v-model="AutoSave"
                            color="primary"
                            class="mt-0 pt-0 shrink"
                            hide-details
                            label="ذخیره خودکار"
                          ></v-switch>

                          <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                          <v-tooltip bottom max-width="320">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                x-small
                                class="mr-1"
                                v-bind="attrs"
                                v-on="on"
                                @click.stop
                              >
                                <v-icon small color="grey darken-1">
                                  mdi-help-circle-outline
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>
                              تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                            </span>
                          </v-tooltip>
                        </div>

                        <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                        <div
                          v-if="$vuetify.breakpoint.xsOnly"
                          class="text-caption grey--text text--darken-1 mt-1 pr-1"
                          style="line-height: 1.4"
                        >
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                        </div>
                      </div>


                </div>

                <list-expansion
                  flat
                  icon="pencil-ruler"
                  single
                  :title="$t('select_template_design')"
                  @save-required="AutoSave && qrUpdate(false)"

                >
                  <template v-slot:content>
                    <theme-selector v-model="theme" :components="customTheme" />
                  </template>
                </list-expansion>
                <list-expansion
                  v-model="cardTexts"
                  :components="specialInfo"
                  :data="cardTexts"
                  flat
                  @save-required="AutoSave && qrUpdate(false)"

                />
                <qr-generator ref="qrGenerator" v-model="cardTexts"  @save-required="AutoSave && qrUpdate(false)"/>

                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="qrUpdate(true)"
                  />
                </div>
              </v-stepper-content>
            </v-stepper>

            <div class="d-none">
              <qr-code-make
                ref="qrCanvas"
                v-model="qrDesign"
                :file.sync="qrSvgDataUrl"
                :link="fullLink"
                @save="qrDesign = $event"
              />
            </div>
          </v-row>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="cons"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download-d`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('download_qr')"
            />
          </template>
          <v-card class="pa-5">
              <download-file-with-api
              v-if="showDialog"
              :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
              :qr_id="info.qrId"
              :visit-name="cardTexts.visitName"
              @close="showDialog = false"
            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
    <QrIntroModal
        storageKey="cardVisitProIntroSeen"
        title="کیوآر کارت ویزیت پرو"
        :pro="true"
        icon="mdi-card-account-details"
        iconColor="blue darken-2"
        :description="introText"
      />

  </help-info-wrapper>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import QrIntroModal from "../QrIntroModal.vue";
import { mapActions } from "vuex";
import MobileViwer from "./components/mobileViwer";
import QrGenerator from "./components/qrGenerator";
import QrMaker from "./components/qrMaker";
import { Bus, debounce } from "@/main";
import QrCustomize from "./components/qrCustomize";
import QrManagement from "./components/qrManage/qrManagement";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import QrAddressField from "../../content/fragments/qrAddressField";
import VisitThemeTwo from "./components/themes/visitThemeTwo";
import ThemeSelector from "./components/themes/themeSelector";
import VisitThemeFlipped from "./components/themes/visitThemeFlipped";
import PreparedCards from "@/view/pages/qrland/preparedCards";
import QrCodeMake from "./qrCodeStyle/qrCodeMake";
import { getLanguageCookie } from "../../../core/plugins/TitleRibbon/utils/languageCookie";
import { setDragging } from "@/utilities/DraggingKeysOrder";
import DownloadFileWithApi from "./downloadFileWithApi.vue";
import Tariffs from "../../components/Tariffs/Tariffs.vue";

export default {
  name: "cardVisitPro",

  components: {
    QrCodeMake,
    PreparedCards,
    ThemeSelector,
    VisitThemeTwo,
    VisitThemeFlipped,
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrManagement,
    DownloadFileWithApi,
    QrCustomize,
    QrMaker,
    QrGenerator,
    MobileViwer,
    Tariffs,
    QrIntroModal,
    AtomSpinner
  },

  data() {
    return {
      isAutoSaving: false, 
      AutoSave:false,

      introText: `
  <strong>کارت ویزیت الکترونیکی Pro کیوآر لند</strong>
  کارت ویزیت دیجیتال و حرفه‌ای برای معرفی شما، برند و کسب‌وکارتان؛ همه اطلاعات تماس، خدمات و محتوا در یک صفحه اختصاصی.
  <br>
  <strong>امکانات:</strong>
  <span style="padding-right: 15px; display: block;">
    <strong>۱. اطلاعات و معرفی:</strong> اطلاعات شخصی، عنوان شغلی و آدرس.<br>
    <strong>۲. شبکه‌های اجتماعی:</strong> لینک شبکه‌ها و راه‌های ارتباطی.<br>
    <strong>۳. گالری تصاویر و ویدیو:</strong> نمونه‌کارها و ویدیوهای معرفی.<br>
    <strong>۴. گالری صوتی:</strong> پیام معرفی یا پادکست.<br>
    <strong>۵. فایل‌های PDF:</strong> کاتالوگ، بروشور، رزومه و منو.<br>
    <strong>۶. فرم درخواست:</strong> دریافت سفارش یا اطلاعات از مشتری.<br>
    <strong>۷. بازخورد مشتریان:</strong> ثبت نظرات و سنجش رضایت.<br>
    <strong>۸. باشگاه مشتریان:</strong> ثبت شماره و ارتباط بیشتر.<br>
    <strong>۹. تنظیمات هوشمند:</strong> شخصی‌سازی نمایش کارت.<br>
    <strong>۱۰. چندزبانه:</strong> مناسب برای مخاطبان بین‌المللی.
  </span>
  <strong>همیشه به‌روز:</strong>
  اطلاعات کارت هر زمان قابل ویرایش است و
  <strong>کد QR داینامیک شما ثابت می‌ماند.</strong>
  بدون نیاز به چاپ مجدد، محتوا را به‌روزرسانی کنید.
`,

      // cardTexts: {
      //   consultation: {
      //     title: "فرم درخواست",
      //     description: "",
      //     sectionColor: { backGround: "", text: "" },
      //     items: {
      //       name: {
      //         is_active: false,
      //         type: "optional",
      //         value: "",
      //         format: "text",
      //         persian: "نام",
      //       },
      //       surname: {
      //         is_active: false,
      //         type: "optional",
      //         value: "",
      //         format: "text",
      //         persian: "نام خانوادگی",
      //       },
      //       phone: {
      //         is_active: false,
      //         type: "optional",
      //         value: "",
      //         format: "number",
      //         persian: "شماره موبایل",
      //       },
      //       mail: {
      //         is_active: false,
      //         type: "optional",
      //         value: "",
      //         format: "text",
      //         persian: "ایمیل",
      //       },
      //       address: {
      //         is_active: false,
      //         type: "optional",
      //         value: "",
      //         format: "text",
      //         persian: "آدرس",
      //       },
      //       nationalId: {
      //         is_active: false,
      //         type: "optional",
      //         value: "",
      //         format: "number",
      //         persian: "کدملی",
      //         verify: "correct",
      //       },
      //       location: {
      //         is_active: false,
      //         type: "optional",
      //         value: "",
      //         format: "text",
      //         persian: "لوکیشن",
      //       },
      //       custom: {
      //         is_active: false,
      //         type: "optional",
      //         value: "",
      //         format: "select",
      //         extra: {
      //           label: "",
      //           options: [],
      //         },
      //       },
      //       description: {
      //         is_active: false,
      //         type: "optional",
      //         value: "",
      //         format: "text",
      //         persian: "توضیحات",
      //       },
      //     },
      //   },
      //   consultationNew: {
      //     title: "فرم درخواست",
      //     description: "",
      //     sectionColor: { backGround: "", text: "" },
      //     conform: false,
      //   },
      //  FeedBack: {
      //     title: "بازخورد شما",
      //     description:
      //       "لطفا با پاسخ گویی به سوالات زیر مارا در خدمات بهتر راهنمایی فرمایید",
      //     sectionColor: {
      //       backGround: "linear-gradient(to right , #FFFFFFFF, #FFFFFFFF)",
      //       text: "#fff",
      //     },
      //     type: "text",
      //     items: [
      //       {
      //         question: "چقدر از خدمات کیوآرلند راضی بوده اید؟",
      //         type: "star",
      //         value: null,
      //         description: false,
      //         forceDesc: true,
      //       },
      //       {
      //         question:
      //           "خدمات کیوآرلند چه میزان از نیازهای شما را پوشش داده است؟",
      //         type: "star",
      //         value: null,
      //         description: false,
      //         forceDesc: false,
      //       },
      //       {
      //         question:
      //           "میزان هزینه پرداختی بابت سرویس دریافتی چقدر معقول بوده است؟",
      //         type: "star",
      //         value: null,
      //         description: false,
      //         forceDesc: false,
      //       },
      //       {
      //         question: "برای  بهبود خدمات نظر خود را با ما درمیان بگذارید.",
      //         type: "star",
      //         value: null,
      //         description: true,
      //         forceDesc: true,
      //       },
      //     ],
      //   },
      //   pdf: [
      //     {
      //       name: "گالری پروپزال‌های کیوآرلند",
      //       images: [
      //         {
      //           title: "پروپزال معرفی محصول",
      //           link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D8%B2%D8%A7%D9%84%20%DA%A9%DB%8C%D9%88%D8%A2%D8%B1%DA%A9%D8%AF%20%D9%85%D8%B9%D8%B1%D9%81%DB%8C%20%D9%85%D8%AD%D8%B5%D9%88%D9%84.pdf",
      //           url: "media/productpro.webp",
      //           description:
      //             "معرفی کامل سرویس‌های کیوآرلند، نحوه کار QR کدهای هوشمند، مزایا برای کسب‌وکارها و نمونه کاربردها برای افزایش تعامل مشتریان.",
      //           selected: true,
      //         },
      //         {
      //           title: "پروپزال کارت ویزیت الکترونیکی",
      //           link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D9%88%D8%B2%D8%A7%D9%84%20%DA%A9%D8%A7%D8%B1%D8%AA%20%D9%88%DB%8C%D8%B2%DB%8C%D8%AA%20%D8%A7%D9%84%DA%A9%D8%AA%D8%B1%D9%88%D9%86%DB%8C%DA%A9%DB%8C.pdf",
      //           url: "media/cardvisit.webp",
      //           description:
      //             "معرفی کارت ویزیت دیجیتال کیوآرلند، امکانات اشتراک سریع اطلاعات تماس، لینک شبکه‌های اجتماعی و مدیریت حرفه‌ای ارتباط با مشتریان.",
      //           selected: true,
      //         },
      //       ],
      //     },
      //   ],
      //    pdfSelector: {
      //     title: "گالری پی دی اف",
      //     description: "توضیحات",
      //     sectionColor: {
      //       backGround: "#FFFFFF",
      //       text: "#333333",
      //     },
      //     slider: false,
      //     layout: "list",
      //   },
      //   pallete: {
      //     headColor: "linear-gradient(to right , #1AD6D8FF, #7915A7FF)",
      //     bodyColor: "linear-gradient(to top left , #9AFEFFFF, #DF99FFFF)",
      //     textColor: "#ffffff",
      //     borderColor: "#393939",
      //     isDarkBody: false,
      //   },
      //   visitName: "کیوآر لند/کارت ویزیت الکترونیکی",
      //   isGradient: true,
      //   organizationName: "کیوآر لند",
      //   subOrgan: "اولین سامانه ساخت کیوآر داینامیک",
      //   userName: "کارت ویزیت الکترونیکی",
      //   workField: null,
      //   phoneNumber: [
      //     { number: "90007425", text: "" },
      //     { number: "02191017077" },
      //   ],
      //   extraFields: [
      //     {
      //       icon: "mdi-card-account-details",
      //       name: "",
      //       value:
      //         "\n🟥مشابه همین کارت ویزیت الکترونیکی را برای کسب و کار خود بسازید.\n🟧3 روز رایگان تست کنید.\n🟨برای ثبت نام رایگان کلیک کنید.",
      //       type: "link",
      //       link: "https://qrland.ir",
      //     },
      //     {
      //       icon: "mdi-qrcode-edit",
      //       name: "",
      //       value:
      //         "کارت ویزیت الکترونیکی شما دارای كيوار دايناميك است.\nدر هر زمان ميتوانيد با موبایل خود اطلاعات را ویرایش کنید.\nكيوآر كد شما هيچگاه پس از ویرایش تغيير نميكند.",
      //     },
      //     {
      //       icon: "",
      //       name: "",
      //       value: "💲هزینه داشتن این کارت ویزیت 900هزار تومان است.",
      //     },
      //     {
      //       icon: "",
      //       name: "",
      //       value: "",
      //       label: "",
      //       type: "icon",
      //     },
      //   ],
      //   companyNumber: "02191017077",
      //   email: "info@qrland.com",
      //   fax: "فکس 02191016066",
      //   location:
      //     "تهران، خیابان شریعتی\nبعد از پل سید خندان، بن بست خندان ، پلاک 6 ",
      //   city: "",
      //   photo: {
      //     profile: "https://cdn.terminalads.com/upload/64b11ae97aae0.webp",
      //     transition: "scale",
      //     hasWelcome: false,
      //     headBackground: "https://cdn.terminalads.com/upload/67af0711b00c2.webp",
      //     gallery: [
      //       {
      //         name: "ما همیشه کنار شما خواهیم ماند...",
      //         images: [
      //           {
      //             name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_possibilities",
      //             title: "",
      //             url: "https://cdn.terminalads.com/upload/67af06f647f05.webp",
      //             description: "",
      //             link: "",
      //             id: 1147899,
      //           },
      //           {
      //             name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_possibilities",
      //             title: "",
      //             url: "https://cdn.terminalads.com/upload/67af0711b00c2.webp",
      //             description: "",
      //             link: "",
      //             id: 1147900,
      //           },
      //           {
      //             name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_features_of_clearer_QR_code",
      //             title: "",
      //             url: "https://cdn.terminalads.com/upload/67af07463ae3d.webp",
      //             description: "",
      //             link: "",
      //             id: 1147902,
      //           },
      //           {
      //             name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_features_of_clearer_QR_code",
      //             title: "",
      //             url: "https://cdn.terminalads.com/upload/67af072f1425c.webp",
      //             description: "",
      //             link: "",
      //             id: 1147901,
      //           },
      //         ],
      //       },
      //     ],
      //     hasGif: false,
      //     hasGame: false,

      //     previewerQr: {
      //       previewer: {
      //         gif: "",
      //         game: {},
      //         transition: "scale",
      //       },
      //     },
      //   },
      //   codePostal: "کد پستی 1541946815",
      //   province: "",
      //   country: "",
      //   website: "www.qrland.ir",
      //   socialMedia: {
      //     address: [
      //       {
      //         hint: " لطفا آدرس آدرس خودرا وارد کنید ",
      //         label: "آدرس",
      //         url: "www.qrland.ir",
      //         img: "/media/socialIcon/40icon/location.svg",
      //         svg: "svgLocation",
      //         prefix: "URL",
      //         pattern: "",
      //       },
      //       {
      //         hint: " لطفا آدرس آدرس خودرا وارد کنید ",
      //         label: "آدرس",
      //         url: "www.qr.terminalads.com",
      //         img: "/media/socialIcon/40icon/location.svg",
      //         svg: "svgLocation",
      //         prefix: "URL",
      //         pattern: "",
      //       },
      //     ],
      //     instagram: [
      //       {
      //         hint: " لطفا آدرس اینستاگرام خودرا وارد کنید ",
      //         label: "اینستاگرام",
      //         url: "https://instagram.com/terminalads",
      //         img: "/media/socialIcon/40icon/instagram.svg",
      //         svg: "svgInstagram",
      //         prefix: "@",
      //         pattern: "https://instagram.com/",
      //       },
      //     ],
      //     whatsapp: [
      //       {
      //         hint: " لطفا آدرس واتساپ خودرا وارد کنید ",
      //         label: "واتساپ",
      //         url: "+982191017077",
      //         img: "/media/socialIcon/40icon/whatsapp.svg",
      //         svg: "svgWhatsapp",
      //         prefix: "mdi-phone",
      //         pattern: "https://wa.me/",
      //       },
      //     ],
      //   },
      //   aboutUs:
      //     'باتوجه به مشکلات موجود در کارت ویزیت فیزیکی\nسامانه کیوآر لند محصولی به نام "کارت ویزیت الکترونیکی"\nرا ارائه نموده است.\nو با استفاده از تکنولوژی های دیجیتالی\nتوانسته مشکلات و محدودیت های موجود در\nکارت ویزیت های فیزیکی را به طور کامل برطرف نماید.\nهمزمان، با جایگزین کردن هوشمندی، از قطع بی رویه درختان جلوگیری کنید.',
      //   coordinates: [51.44664929903732, 35.743057774101274],
      //   address:
      //     "ایران، تهران، شهر تهران، تهران، منطقه ۳ شهر تهران، محله سید خندان، دکتر علی شریعتی، خندان",
      //   apiKey:
      //     "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      //   video_gallery: [
      //     {
      //       name: "",
      //       images: [
      //         {
      //           name: "چرا کارت ویزیت کیو آر لند؟ کیو آر لند با بقیه چه فرقی داره؟",
      //           title: "چرا کارت ویزیت کیوآر لند",
      //           file_link:
      //             "https://www.aparat.com/video/video/embed/videohash/okn5zhp/vt/frame",
      //           description: "",
      //           link: "",
      //           id: 456,
      //         },
      //         {
      //           name: "معرفی کارت ویزیت الکترنیکی کیوآر لند",
      //           title: "بهترین جایگزین کارت ویزیت فیزیکی",
      //           file_link:
      //             "https://www.aparat.com/video/video/embed/videohash/zmyd3vb/vt/frame",
      //           description: "",
      //           link: "",
      //           id: 267,
      //         },
      //       ],
      //     },
      //   ],
      //   customerClub: {
      //     configs: {
      //       patternId: 499,
      //       smsType: "pattern",
      //       isActive: true,
      //       message: {
      //         data1: {
      //           text: "name",
      //           state: "userInfo",
      //         },
      //         data2: {
      //           text: "lastName",
      //           state: "userInfo",
      //         },
      //       },
      //     },
      //     title: "عضویت در باشگاه مشتریان",
      //     description: "این یک باشگاه مشتریان عادی نیست!\nشمارتو ثبت کن",
      //   },
      //   advanceSettings: {
      //     viewConfigs: {
      //       autoCsvDownload: false,
      //       showCClubOnload: false,
      //       forcedSubmission: "optional",
      //     },
      //     hasManifestIcons: true,
      //     manifest: {
      //       icon48: "https://cdn.terminalads.com/upload/67d49c914b6d1.webp",
      //       icon144: "https://cdn.terminalads.com/upload/67d49c918fa23.webp",
      //       screenshotWide: "",
      //       screenshot600: "",
      //     },
      //     hasAssistants: false,
      //     aiChatConfig: {
      //       // assistant: {
      //       //   id: 14,
      //       //   name: "کارت ویزیت الکترونیکی کیوآر لند",
      //       //   type: "دستیار فروش",
      //       //   uniq_key: "1d463a8f577704c5ec668894a1a60e29",
      //       //   link: "t7r.ir/1cOsj1",
      //       //   design: {
      //       //     config: {
      //       //       settings: {
      //       //         assistantName: "دستیار هوشمند",
      //       //         assistantDescription:
      //       //           "سلام! من دستیار هوشمند شما هستم. سوال خود را بپرسید",
      //       //       },
      //       //       assistant: null,
      //       //       assistantId: null,
      //       //       chatSettings: {
      //       //         chatLogo: null,
      //       //         fontSize: 14,
      //       //         textColor: "#333333",
      //       //         headerColor: "#667eea",
      //       //         floatingIcon: "mdi-robot",
      //       //         headerColor2: "#764ba2",
      //       //         useImageLogo: false,
      //       //         headerGradient: true,
      //       //         backgroundColor: "#ffffff",
      //       //         backgroundImage: null,
      //       //         useImageBackground: false,
      //       //       },
      //       //       hasAssistantsName: false,
      //       //       hasAssistantsFamily: false,
      //       //       hasAssistantsMobile: false,
      //       //     },
      //       //     assistantId: 14,
      //       //     chatSettings: {
      //       //       chatLogo: null,
      //       //       fontSize: 20,
      //       //       textColor: "#FF0000FF",
      //       //       headerColor: "#002EFFFF",
      //       //       floatingIcon: "mdi-chat",
      //       //       headerColor2: "#7E00FFFF",
      //       //       useImageLogo: false,
      //       //       headerGradient: true,
      //       //       backgroundColor: "#FF0000FF",
      //       //       backgroundImage: null,
      //       //       useImageBackground: false,
      //       //     },
      //       //     assistantName: null,
      //       //     hasAssistants: false,
      //       //     hasAssistantsName: true,
      //       //     hasAssistantsFamily: true,
      //       //     hasAssistantsMobile: true,
      //       //   },
      //       //   expired_at: "2027-01-01T04:26:49.000000Z",
      //       // },
      //       // assistantId: 14,
      //       // chatSettings: {
      //       //   headerColor: "#1AD6D8FF",
      //       //   headerColor2: "#7915A7FF",
      //       //   headerGradient: true,
      //       //   backgroundColor: "#FFFFFFFF",
      //       //   backgroundImage: "",
      //       //   useImageBackground: false,
      //       //   textColor: "#0081FCFF",
      //       //   fontSize: 14,
      //       //   chatLogo: null,
      //       //   floatingIcon: "mdi-headset",
      //       //   useImageLogo: false,
      //       // },
      //       // hasAssistantsName: false,
      //       // hasAssistantsFamily: false,
      //       // hasAssistantsMobile: false,
      //     },
      //   },
      //   tab_design: 1,
      //   audiosGallery: {
      //     audios: [
      //       {
      //         id: 1941300,
      //         category: "همه",
      //         title: "راهنمای جامع کارت ویزیت الکترونیکی",
      //         md5: "0cf572d4e658fe4ca5345f52677d08da",
      //         path: "upload/686a93cf44e5c.wav",
      //         type: "other",
      //         file_type: "audio",
      //         created_at: "2025-07-06T15:18:39.000000Z",
      //         updated_at: "2025-07-06T15:18:39.000000Z",
      //         full_path: "https://cdn.terminalads.com/upload/686a93cf44e5c.wav",
      //         created_at_p: "1404-04-15 18:48:39",
      //         updated_at_p: "1404-04-15 18:48:39",
      //         created_at_diff: "1 ثانیه پیش",
      //         updated_at_diff: "1 ثانیه پیش",
      //         autoPlay: false,

      //       },
      //     ],
      //     audioType: "newPlayer",
      //   },
      //   language: "fa",
      //   langs: {
      //     source_lang: "fa",
      //     other_langs: [
      //       { lang: "en_US", status: "edited" },
      //       { lang: "en_GB", status: "edited" },
      //       { lang: "ar", status: "edited" },
      //       { lang: "ar_iq", status: "edited" },
      //       { lang: "de", status: "edited" },
      //       { lang: "fr", status: "edited" },
      //       { lang: "hy", status: "edited" },
      //       { lang: "ru", status: "edited" },
      //       { lang: "tr", status: "edited" },
      //       { lang: "zh_CN", status: "edited" },
      //       { lang: "zh_TW", status: "edited" },
      //       { lang: "ar_ae", status: "edited" },
      //     ],
      //   },
      // },
      orders: [
        { name: "userName" },
        { name: "workField" },
        { name: "aboutUs" },
        { name: "extraFields" },
        { name: "video_gallery" },
        { name: "photo" },
        { name: "FeedBack" },
        { name : "consultation"},
        { name: "phoneNumber" },
        { name: "fax" },
        { name: "location" },
        { name: "codePostal" },
        { name: "email" },
        { name: "website" },
        { name: "audio_0" },
      ],
      theme: "MobileViwer",
      showconnect: false,
      connectionCode: null,
      loadingconnetion: false,
      svgMade:"",
      helpData: [],
      componentName: "cardVisit",
      serviceName: "Qrland",
      info: null,
      qrDesign: {},
      e6: 1,
      errors: {},
      createdId: null,
      createdDomain: null,
      ready: false,
      loading: false,
      showDialog: false,
      customTheme: [
        { name: "MobileViwer", value: "" },
        { name: "VisitThemeTwo", value: "" },
        { name: "VisitThemeFlipped", value: "" },
      ],
      dtUrl: null,
      domainId: null,
      qrShow: 1,
      qrSvgDataUrl: "",
    };
  },

  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.updateTransition();

    Bus.$on("showconnect", (val) => {
      this.showconnect = val;
    });

    Bus.$on("colorPalette", (value) => {
      this.cardTexts.pallete = value;
    });
    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });
    Bus.$on("uploader", (value) => {
      this.cardTexts.photo = value;
    });

    this.setKeys(this.cardTexts);
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
        this.updateTransition();
      }
    },
    cardTexts: {
      deep: true,
      handler(newVal) {
        debounce(() => {
          this.setKeys(newVal);
        }, 300);
      },
    },
    "cardTexts.photo.gallery": {
      deep: true,
      handler(val) {
        debounce(() => {
          if (!val) this.cardTexts.photo.gallery = [{ name: "", images: [] }];
          this.$root.$emit("rerenderSwiper");
        }, 1000);
      },
    },
  },

  computed: {
  cardTexts() {
    return {
        consultation: {
          title: this.$t('card.consultation.title'),
          description: "",
          sectionColor: { backGround: "", text: "" },
          items: {
            name: { is_active: false, type: "optional", value: "", format: "text", persian: this.$t('card.form.name') },
            surname: { is_active: false, type: "optional", value: "", format: "text", persian: this.$t('card.form.surname') },
            phone: { is_active: false, type: "optional", value: "", format: "number", persian: this.$t('card.form.phone') },
            mail: { is_active: false, type: "optional", value: "", format: "text", persian: this.$t('card.form.email') },
            address: { is_active: false, type: "optional", value: "", format: "text", persian: this.$t('card.form.address') },
            nationalId: { is_active: false, type: "optional", value: "", format: "number", persian: this.$t('card.form.national_id'), verify: "correct" },
            location: { is_active: false, type: "optional", value: "", format: "text", persian: this.$t('card.form.location') },
            custom: { is_active: false, type: "optional", value: "", format: "select", extra: { label: "", options: [] } },
            description: { is_active: false, type: "optional", value: "", format: "text", persian: this.$t('card.form.description') },
          },
        },
        consultationNew: {
          title: this.$t('card.consultation.title'),
          description: "",
          sectionColor: { backGround: "", text: "" },
          conform: false,
        },
        FeedBack: {
          title: this.$t('card.feedback.title'),
          description: this.$t('card.feedback.description'),
          sectionColor: { backGround: "linear-gradient(to right , #FFFFFFFF, #FFFFFFFF)", text: "#fff" },
          type: "text",
          items: [
            { question: this.$t('card.feedback.q1'), type: "star", value: null, description: false, forceDesc: true },
            { question: this.$t('card.feedback.q2'), type: "star", value: null, description: false, forceDesc: false },
            { question: this.$t('card.feedback.q3'), type: "star", value: null, description: false, forceDesc: false },
            { question: this.$t('card.feedback.q4'), type: "star", value: null, description: true, forceDesc: true },
          ],
        },
        pdf: [
          {
            name: this.$t('card.pdf.gallery_name'),
            images: [
              {
                title: this.$t('card.pdf.item1_title'),
                link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D8%B2%D8%A7%D9%84%20%DA%A9%DB%8C%D9%88%D8%A2%D8%B1%DA%A9%D8%AF%20%D9%85%D8%B9%D8%B1%D9%81%DB%8C%20%D9%85%D8%AD%D8%B5%D9%88%D9%84.pdf",
                url: "media/productpro.webp",
                description: this.$t('card.pdf.item1_desc'),
                selected: true,
              },
              {
                title: this.$t('card.pdf.item2_title'),
                link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D9%88%D8%B2%D8%A7%D9%84%20%DA%A9%D8%A7%D8%B1%D8%AA%20%D9%88%DB%8C%D8%B2%DB%8C%D8%AA%20%D8%A7%D9%84%DA%A9%D8%AA%D8%B1%D9%88%D9%86%DB%8C%DA%A9%DB%8C.pdf",
                url: "media/cardvisit.webp",
                description: this.$t('card.pdf.item2_desc'),
                selected: true,
              },
            ],
          },
        ],
        pdfSelector: {
          title: this.$t('card.pdf_selector.title'),
          description: this.$t('card.pdf_selector.description'),
          sectionColor: { backGround: "#FFFFFF", text: "#333333" },
          slider: false,
          layout: "list",
        },
        pallete: {
          headColor: "linear-gradient(to right , #1AD6D8FF, #7915A7FF)",
          bodyColor: "linear-gradient(to top left , #9AFEFFFF, #DF99FFFF)",
          textColor: "#ffffff",
          borderColor: "#393939",
          isDarkBody: false,
        },
        visitName: this.$t('card.info.visit_name'),
        isGradient: true,
        organizationName: this.$t('card.info.organization_name'),
        subOrgan: this.$t('card.info.sub_organ'),
        userName: this.$t('card.info.user_name'),
        workField: null,
        phoneNumber: [
          { number: "90007425", text: "" },
          { number: "02191017077" },
        ],
        extraFields: [
          {
            icon: "mdi-card-account-details",
            name: "",
            value: this.$t('card.extra.field1'),
            type: "link",
            link: "https://qrland.ir",
          },
          {
            icon: "mdi-qrcode-edit",
            name: "",
            value: this.$t('card.extra.field2'),
          },
          {
            icon: "",
            name: "",
            value: this.$t('card.extra.field3'),
          },
          { icon: "", name: "", value: "", label: "", type: "icon" },
        ],
        companyNumber: "02191017077",
        email: "info@qrland.com",
        fax: this.$t('card.info.fax'),
        location: this.$t('card.info.location_desc'),
        city: "",
        photo: {
          PicSelector: {
              slider: true,
              grid: false,
              orientation:'horizontal',
            },
          profile: "https://cdn.terminalads.com/upload/64b11ae97aae0.webp",
          transition: "scale",
          hasWelcome: false,
          headBackground: "https://cdn.terminalads.com/upload/67af0711b00c2.webp",
          gallery: [
            {
              name: this.$t('card.gallery.name'),
              images: [
                   {
                  name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_possibilities",
                  title: "",
                  url: "https://cdn.terminalads.com/upload/67af06f647f05.webp",
                  description: "",
                  link: "",
                  id: 1147899,
                },
                {
                  name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_possibilities",
                  title: "",
                  url: "https://cdn.terminalads.com/upload/67af0711b00c2.webp",
                  description: "",
                  link: "",
                  id: 1147900,
                },
                {
                  name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_features_of_clearer_QR_code",
                  title: "",
                  url: "https://cdn.terminalads.com/upload/67af07463ae3d.webp",
                  description: "",
                  link: "",
                  id: 1147902,
                },
                {
                  name: "dynamic_QR_code_in_a_vibrant_atmosphere_with_many_features_of_clearer_QR_code",
                  title: "",
                  url: "https://cdn.terminalads.com/upload/67af072f1425c.webp",
                  description: "",
                  link: "",
                  id: 1147901,
                },
              ],
            },
          ],
          hasGif: false,
          hasGame: false,
          previewerQr: { previewer: { gif: "", game: {}, transition: "scale" } },
        },
        codePostal: this.$t('card.info.postal_code'),
        province: "",
        country: "",
        website: "www.qrland.ir",
        socialMedia: {
          address: [
            { hint: this.$t('card.social.address_hint'), label: this.$t('card.social.address_label'), url: "www.qrland.ir", img: "/media/socialIcon/40icon/location.svg", svg: "svgLocation", prefix: "URL", pattern: "" },
            { hint: this.$t('card.social.address_hint'), label: this.$t('card.social.address_label'), url: "www.qr.terminalads.com", img: "/media/socialIcon/40icon/location.svg", svg: "svgLocation", prefix: "URL", pattern: "" },
          ],
          instagram: [
            { hint: this.$t('card.social.instagram_hint'), label: this.$t('card.social.instagram_label'), url: "https://instagram.com/terminalads", img: "/media/socialIcon/40icon/instagram.svg", svg: "svgInstagram", prefix: "@", pattern: "https://instagram.com/" },
          ],
          whatsapp: [
            { hint: this.$t('card.social.whatsapp_hint'), label: this.$t('card.social.whatsapp_label'), url: "+982191017077", img: "/media/socialIcon/40icon/whatsapp.svg", svg: "svgWhatsapp", prefix: "mdi-phone", pattern: "https://wa.me/" },
          ],
        },
        aboutUs: this.$t('card.info.about_us'),
        coordinates: [51.44664929903732, 35.743057774101274],
        address: this.$t('card.info.full_address'),
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",        video_gallery: [
          {
            name: "",
            images: [
              {
                name: this.$t('card.video.item1_name'),
                title: this.$t('card.video.item1_title'),
                file_link:
                  "https://www.aparat.com/video/video/embed/videohash/okn5zhp/vt/frame",
                description: "", link: "", id: 456,
              },
              {
                name: this.$t('card.video.item2_name'),
                title: this.$t('card.video.item2_title'),
                file_link:
                  "https://www.aparat.com/video/video/embed/videohash/zmyd3vb/vt/frame",
                description: "", link: "", id: 267,
              },
            ],
          },
        ],
        customerClub: {
          configs: { patternId: 499, smsType: "pattern", isActive: true, message: { data1: { text: "name", state: "userInfo" }, data2: { text: "lastName", state: "userInfo" } } },
          title: this.$t('card.club.title'),
          description: this.$t('card.club.description'),
        },
        advanceSettings: {
          viewConfigs: { autoCsvDownload: false, showCClubOnload: false, forcedSubmission: "optional" },
          hasManifestIcons: true,
          manifest: {
            icon48: "https://cdn.terminalads.com/upload/67d49c914b6d1.webp",
            icon144: "https://cdn.terminalads.com/upload/67d49c918fa23.webp",
            screenshotWide: "",
            screenshot600: "",
          },
          hasAssistants: false,
          aiChatConfig: {},
        },
        tab_design: 1,
        audiosGallery: {
          audios: [
            {
              id: 1941300,
              category: this.$t('card.audio.category_all'),
              title: this.$t('card.audio.item1_title'),
              md5: "0cf572d4e658fe4ca5345f52677d08da",
              path: "upload/686a93cf44e5c.wav",
              type: "other",
              file_type: "audio",
              created_at: "2025-07-06T15:18:39.000000Z",
              updated_at: "2025-07-06T15:18:39.000000Z",
              full_path: "https://cdn.terminalads.com/upload/686a93cf44e5c.wav",
             created_at_p: "1404-04-15 18:48:39", updated_at_p: "1404-04-15 18:48:39",
              created_at_diff: this.$t('card.audio.diff_seconds'),
              updated_at_diff: this.$t('card.audio.diff_seconds'),
              autoPlay: false,
            },
          ],
          audioType: "newPlayer",
        },
        language: "fa",
        langs: {
          source_lang: "fa",
          other_langs: [
            { lang: "en_US", status: "edited" },
            { lang: "en_GB", status: "edited" },
            { lang: "ar", status: "edited" },
            { lang: "ar_iq", status: "edited" },
            { lang: "de", status: "edited" },
            { lang: "fr", status: "edited" },
            { lang: "hy", status: "edited" },
            { lang: "ru", status: "edited" },
            { lang: "tr", status: "edited" },
            { lang: "zh_CN", status: "edited" },
            { lang: "zh_TW", status: "edited" },
            { lang: "ar_ae", status: "edited" },
          ],
        },
      }
    },
    cons() {
      return { title: this.$t("download_qr") };
    },
    helpElements() {
      return [
        { name: "visitName", label: this.$t("visit_card_name") },
        { name: "dtUrl", label: this.$t("qr_address") },
        { name: "themeSelector", label: this.$t("select_template_design") },
        { name: "clearDefaults", label: this.$t("remove_default_info") },
        { name: "preparedCards", label: this.$t("select_ready_card") },
      ];
    },
    specialInfo() {
      return [
        {
          name: "textCards",
          value: "",
          title: this.$t("user_info"),
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "customerClubSettings",
          title: this.$t("sms_club_membership"),
          icon: "cellphone-message",
          model: "customerClub",
        },
        {
          name: "advanceSettings",
          title: this.$t("smart_settings"),
          icon: "star-settings-outline",
          model: "advanceSettings",
        },
        {
          name: "voiceGallery",
          title: this.$t("add_audio_file"),
          icon: "microphone",
          model: "audiosGallery",
        },
        {
          name: "addLanguage",
          title: this.$t("language.add_langs"),
          icon: "translate",
          model: "langs",
        },
          {
          name: "pdfSelector",
          value: "",
          title: this.$t("ROUTE.TITLES.QR_PDF"),
          subtitle: "",
          icon: "file-outline",
        },
        {
          name: "FeedBack",
          value: "",
          title: this.$t("feedback"),
          subtitle: "",
          icon: "reply-outline",
          model: "FeedBack",
        },
        {
          name: "consultationNew",
          value: "",
          title: this.$t("request_form"),
          subtitle: "",
          icon: "list-box-outline",
          model: "consultationNew",
        },
      ];
    },

    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    setKeys(val = this.cardTexts) {
      let keys = setDragging(val, this.orders);
      if (
        val.audiosGallery &&
        val.audiosGallery.audios &&
        val.audiosGallery.audios.length > 0
      ) {
        const audioKeys = val.audiosGallery.audios.map((_, index) => ({
          name: `audio_${index}`,
        }));
        keys = [
          ...keys.filter((key) => !key.name.startsWith("audio_")),
          ...audioKeys,
        ];
      }

      keys = keys.filter((item) => item.name !== "audiosGallery");

      keys = keys.filter(
        (item) => item.name !== "langs" && item.name !== "language",
      );

      this.orders = keys;
      this.$forceUpdate();
    },
    updateTransition() {
      this.cardTexts.userName = this.$t("qrland");
      this.cardTexts.workField = this.$t("dynamic");
      this.cardTexts.aboutUs = this.$t("about_us_text");
      this.cardTexts.location = this.$t("address_text");
      this.cardTexts.visitName = this.$t("visit_card");
      this.cardTexts.organizationName = this.$t("qrland_system");
      this.cardTexts.subOrgan = this.$t("qrland_first_system");

      if (
        this.cardTexts.video_gallery &&
        this.cardTexts.video_gallery.length > 0
      ) {
        this.cardTexts.video_gallery[0].name = this.$t("video_gallery");
      }
      this.cardTexts.socialMedia = {
        address: [
          {
            label: this.$t("address"),
            text: this.$t("enter_site_link"),
            hint: this.$t("enter_site_link"),
            pattern: "",
            prefix: "URL",
            url: "qrland.ir",
            img: "/media/socialIcon/40icon/location.svg",
            svg: "svgLocation",
          },
          {
            label: this.$t("address"),
            text: this.$t("enter_site_link"),
            hint: this.$t("enter_site_link"),
            pattern: "",
            prefix: "URL",
            url: "qr.terminalads.com",
            img: "/media/socialIcon/40icon/location.svg",
            svg: "svgLocation",
          },
        ],
        instagram: [
          {
            label: this.$t("instagram"),
            text: this.$t("enter_instagram_username"),
            hint: this.$t("enter_instagram_username"),
            pattern: "https://instagram.com/",
            prefix: "@",
            url: "terminalads",
            img: "/media/socialIcon/40icon/instagram.svg",
            svg: "svgInstagram",
          },
        ],
        whatsapp: [
          {
            label: this.$t("whatsapp"),
            text: "+982191017077",
            hint: "+982191017077",
            pattern: "https://wa.me/",
            prefix: "mdi-phone",
            url: "+982191017077",
            img: "/media/socialIcon/40icon/whatsapp.svg",
            svg: "svgWhatsapp",
          },
        ],
      };
    },
    markQr() {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error(this.$t("invalid_qr_address"));
        return;
      }

      this.loading = true;
      this.cardTexts.language = getLanguageCookie()
        ? getLanguageCookie()
        : "fa";
      this.cardTexts.langs = {
        source_lang: this.cardTexts.language,
        other_langs: [],
      };
      let obj = {
        type: "visitcardpro",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: this.theme,
          data: this.cardTexts,
          orders: this.orders,
        }),
        qr: JSON.stringify(this.qrDesign),
      };
      if (!!this.connectionCode) obj.special_code = this.connectionCode;

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.createdId = data.data.identifier;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.info = data.data;
          this.qrShow = 0;
          this.setCreatedQrID(data.data.id);
          this.$toast.success(this.$t("visit_card_created_successfully"));
          if (this.e6 === 1) {
            this.e6 = 2;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate();
                this.qrShow = 1;
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }

      const data = new FormData();
      data.append("type", "visitcardpro");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("_method", "PUT");
      data.append("qr", JSON.stringify(this.qrDesign));
      data.append("qr_id", this.info.qrId);
      this.cardTexts.language = getLanguageCookie()
        ? getLanguageCookie()
        : "fa";

      data.append(
        "data",
        JSON.stringify({
          theme: this.theme,
          data: this.cardTexts,
          orders: this.orders,
        }),
      );
      let finaldata = {
        theme: this.theme,
        data: this.cardTexts,
        orders: this.orders,
      };
      let allLangs = [];
      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then(({ data }) => {
          if (final) {
            this.info = data.data;
            allLangs = [
              this.cardTexts.language,
              ...(this.cardTexts?.langs?.other_langs || []).map((l) => l.lang),
            ];
            if (allLangs.length > 0 && final) {
              this.$api
                .post(`/v1/testQr/update-lang-data/${data.data.id}`, {
                  data: finaldata,
                  langs: allLangs,
                })
                .then((data) => {
                  if(final)
                  this.goto("qr/list");
                  this.qrShow = 0;
                })
                .catch((err) => {})
                .finally(() => {
                  this.loading = false;
                  this.isAutoSaving = false;
                if(final)
                  this.$toast.success(
                    this.$t("visit_card_edited_successfully"),
                  );
                });
            }
          }
        })
        .catch((err) => {})
        .finally(() => {
          if (final) {
            this.goto("qr/list");
            this.qrShow = 0;
          }
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
    clearDefaults() {
      this.$root.$emit("clearDefaultData");
      this.cardTexts.customerClub= {
          configs: {
          },
          title: "",
          description: "",
        };
      this.cardTexts.photo= {
          PicSelector: {
              slider: true,
              grid: false,
              orientation:'horizontal',
            },
          profile: "",
          transition: "scale",
          hasWelcome: false,
          headBackground: "",
          gallery: [
            {
              name: "",
              images: [
              ],
            },
          ],
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
            },
          },
        };
      this.cardTexts.advanceSettings= {
          viewConfigs: {
          },
          hasManifestIcons: false,
          manifest: {
          },
          hasAssistants: false,
          aiChatConfig: {
          },
        };
        this.cardTexts.audiosGallery= {
          audios: [],
          audioType: "",
        };

        this.cardTexts.video_gallery= [
          {
            name: "",
            images: [
            ],
          },
        ];
 
       this.cardTexts.pdf= [
          {
            name: "",
            images: [
            ],
          },
        ],
      this.cardTexts.consultation= {
          title: "",
          description: "",
          sectionColor: { backGround: "", text: "" },
          items: {
          },
        };
        this.cardTexts.consultationNew= {
          title: "",
          description: "",
          sectionColor: { backGround: "", text: "" },
          conform: false,
        };

      this.cardTexts.visitName = "";
      this.cardTexts.organizationName = "";
      this.cardTexts.photo.previewerQr.previewer.gif = "";
      this.cardTexts.photo.previewerQr.previewer.game = null;
      this.cardTexts.subOrgan = "";
      this.cardTexts.userName = "";
      this.cardTexts.workField = "";
      this.cardTexts.phoneNumber = [{ number: "" }];
      this.cardTexts.banner= { gallery: [] };
      this.cardTexts.extraFields = [
        {
          icon: "",
          name: "",
          value: "",
        },
      ];
      this.cardTexts.pdfSelector = {
          title: "",
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
          layout: "list",
        };
        this.cardTexts.FeedBack = {
          title: "",
          description:
            "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          type: "",
          items: [],
        };
          this.cardTexts.VideoGallery= {
            description: "",
            sectionColor: { backGround: "", text: "" },
          };
                    this.cardTexts.FeedBack= {
            description: "",
            sectionColor: { backGround: "", text: "" },
            type: "",
            items: [],
          };
this.cardTexts.consultation= {
            description: "",
            sectionColor: { backGround: "", text: "" },
            items: {
              name: {
                is_active: false,
                type: "optional",
                value: "",
                format: "text",
              },
              surname: {
                is_active: false,
                type: "optional",
                value: "",
                format: "text",
              },
              phone: {
                is_active: false,
                type: "optional",
                value: "",
                format: "number",
              },
              mail: {
                is_active: false,
                type: "optional",
                value: "",
                format: "text",
              },
              address: {
                is_active: false,
                type: "optional",
                value: "",
                format: "text",
              },
              nationalId: {
                is_active: false,
                type: "optional",
                value: "",
                format: "number",
                verify: "correct",
              },
              location: {
                is_active: false,
                type: "optional",
                value: "",
                format: "text",
              },
              custom: {
                is_active: false,
                type: "optional",
                value: "",
                format: "select",
                extra: { label: "", options: [] },
              },
              description: {
                is_active: false,
                type: "optional",
                value: "",
                format: "text",
              },
            },
          };

      this.cardTexts.companyNumber = "";
      this.cardTexts.email = "";
      this.cardTexts.fax = "";
      this.cardTexts.location = "";
      this.cardTexts.city = "";
      this.cardTexts.photo.gallery = null;
      this.cardTexts.photo.transition = "scale";
      this.cardTexts.photo.hasWelcome = false;
      this.cardTexts.codePostal = "";
      this.cardTexts.province = "";
      this.cardTexts.country = "";
      this.cardTexts.website = "";
      this.cardTexts.socialMedia = {};
      this.cardTexts.aboutUs = "";

      this.cardTexts.video_single = {
        name: "",
        videos: [],
      };
      this.cardTexts.center = [51.420296, 35.732379];
      this.cardTexts.coordinates = [null, null];
      this.cardTexts.address = "";
      this.cardTexts.apiKey =
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg";
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}

.help-info-wrapper {
  display: inline-block;
  vertical-align: middle;
  margin-left: 1px;
}
qr-address-field {
  width: 88% !important;
}
.warp {
  position: relative;
  overflow: visible !important;
  min-height: 50px;
}
.doublebtn {
  gap: 8px;
}
.connect >>> .v-input__append-outer {
  display: flex;
  align-items: center;
  margin: 0 !important;
  padding: 0 5px 0 5px !important;
}
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important; 
  align-self: flex-start;
  height: max-content;
  z-index: 4;
}

</style>
